<div class="sidebar-area dark:bg-[#0c1427] fixed overflow-hidden z-[7] top-0 h-screen transition-all rounded-r-md">
    <div id="scroll-area" class="navigation-hold flex flex-col ps">
        <div
            class="logo flex items-center dark:bg-[#833100] border-b border-gray-100 dark:border-[#833100] px-[25px] py-[8px] absolute z-[2] right-0 top-0 left-0">
            <a routerLink="/dashboard" class="transition-none basis-1/3 relative flex items-center menu-logo">
                <img src="../../../assets/images/logo.png" alt="logo-icon">
            </a>
            <div class="pl-2 flex-grow h-100">
                <h5 class="m-0 text-sm mt-1 ml-2 text-black font-semibold">WBSRLM</h5>
            </div>
        </div>
        <ng-scrollbar visibility="hover" class="!h-screen">
            <div class="pt-[120px] px-[0] pb-[20px]">
                <div class="accordion text-black dark:text-white whitespace-nowrap">
                    <!-- Keep a static Dashboard link at the top -->
                    <div class="accordion-item rounded-md">
                        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]">
                            <i
                                class="material-symbols-outlined transition-all text-white ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px">dashboard</i>
                            <span class="title leading-none">Dashboard</span>
                        </a>
                    </div>

                    <!-- Dynamic menu from navigationService.menuItems() -->
                    <ng-container *ngFor="let top of navigationService.menuItems(); let i = index">
                        <div class="accordion-item rounded-md">
                            <ng-container [ngTemplateOutlet]="menuTpl"
                                [ngTemplateOutletContext]="{ item: top, key: i.toString(), level: 0 }"></ng-container>
                        </div>
                    </ng-container>

                    <br />
                    <div class="accordion-item rounded-md signOut">
                        <div class="divider"></div>
                        <button type="button" (click)="logout()"
                            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]">
                            <i
                                class="material-symbols-outlined transition-all text-white ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px">logout</i>
                            <span class="title leading-none">Sign Out</span>
                        </button>
                    </div>
                </div>

                <!-- Recursive template for menu rendering -->
                <ng-template #menuTpl let-item="item" let-key="key" let-level="level">
                    <!-- Item with children: render as collapsible section -->
                    <!-- <ng-container *ngIf="item?.sub?.length; else leafTpl"> -->
                    @if(item?.sub?.length){
                    <button type="button"
                        class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
                        (click)="toggle(key)" [ngClass]="{ 'open': isOpen(key) }">
                        <i
                            class="material-symbols-outlined transition-all dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px">{{
                            getIcon(item) }}</i>
                        <span class="title leading-none">{{ item.name }}</span>
                    </button>
                    <div class="accordion-collapse" [ngClass]="{ 'open': isOpen(key) }">
                        <div class="pt-[4px]" [ngClass]="{ 'ltr:pl-[0px] rtl:pr-[0px]': level > 0 }">
                            <ul class="sidebar-sub-menusec">
                                <li class="sidemenu-subitem mb-[4px] last:mb-0"
                                    *ngFor="let child of item.sub; let j = index">
                                    <ng-container [ngTemplateOutlet]="menuTpl"
                                        [ngTemplateOutletContext]="{ item: child, key: key + '-' + j, level: level + 1 }">
                                    </ng-container>
                                </li>
                            </ul>
                        </div>
                    </div>
                    }
                    @else {
                    <ng-container *ngTemplateOutlet="leafTpl"></ng-container>
                    }

                    <!-- Leaf item: render as router link; top-level uses button styling, nested uses sidemenu-link -->
                    <ng-template #leafTpl>
                        @if(getRouterLink(item); as link){
                        <a [routerLink]="link" class="transition-all w-full text-left"
                            [ngClass]="level === 0
                                ? 'accordion-button flex items-center py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md hover:bg-gray-50 dark:hover:bg-[#15203c]'
                                : 'sidemenu-link rounded-md flex items-center relative text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 dark:hover:bg-[#15203c]'">
                            @if(level === 0){
                            <i
                                class="material-symbols-outlined transition-all dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px">{{
                                getIcon(item) }}</i>
                            }
                            <span class="title leading-none">{{ item.name }}</span>
                        </a>
                        }
                    </ng-template>
                </ng-template>
            </div>
        </ng-scrollbar>
    </div>
</div>